module.exports = __webpack_public_path__ + "img/apple-icon-180x180.7f5a158e.png";